<template>
  <div v-if="navCollapsed" class="flex h-8 w-8 shrink-0 items-center justify-center">
    <div v-if="logoUrl" class="h-full w-full">
      <img
        v-show="isImageLoaded"
        :src="logoUrl"
        alt="Organization Logo"
        class="h-full w-full rounded-full object-cover"
        @load="onImageLoad"
      />
      <div
        v-show="!isImageLoaded"
        class="h-full w-full animate-pulse rounded-full bg-gray-700"
      ></div>
    </div>
    <Avatar v-else :label="orgName" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { Avatar } from '@boqnet/ui';

withDefaults(
  defineProps<{
    logoUrl?: string | null;
    orgName: string;
    navCollapsed: boolean;
  }>(),
  {
    navCollapsed: true,
  },
);

const isImageLoaded = ref(false);
const onImageLoad = () => {
  isImageLoaded.value = true;
};
</script>
